<template>
  <RoutineSelector
    ref="routineSelector"
    :selectedRoutineIds="selectedRoutineIds"
    @select="$emit('select', $event)"
  >
    <template v-slot:activator="{ selectedRoutines }">
      <v-select
        class="report-routines-filter-activator-container caption white"
        dense
        hide-details
        outlined
        readonly
        ref="routineSelectorActivator"
        :placeholder="$t('menu.selection.select_an_option')"
      >
        <template v-slot:label>
          <div class="white px-1">
            {{ $t('routines.routine_other') }}
          </div>
        </template>

        <template v-slot:selection="{ item, index }">
          <div class="d-flex">
            <v-chip v-if="index < 1" class="mt-1 me-1" outlined small>
              {{ item.name }}
            </v-chip>

            <v-tooltip v-if="index === 1" bottom max-width="400px">
              <template v-slot:activator="{ on }">
                <v-chip v-on="on" small outlined class="mt-1 me-1">
                  + {{ selectedRoutines.length - 1 }}
                </v-chip>
              </template>

              <ul class="ma-0 pa-0 ms-2">
                <div
                  v-for="(option, index) in selectedRoutines"
                  :key="option.id"
                >
                  <li v-if="index >= 1" class="ma-0 pa-0">
                    {{ option.name }}
                  </li>
                </div>
              </ul>
            </v-tooltip>
          </div>
        </template>
      </v-select>
    </template>
  </RoutineSelector>
</template>

<script>
import RoutineSelector from '@/components/RoutineSelector/RoutineSelector.vue'

export default {
  name: 'RoutineDefinitionsFilter',

  components: {
    RoutineSelector,
  },

  props: {
    selectedRoutineIds: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectionWatcher: null,
    }
  },

  mounted() {
    this.setupSelectedRoutinesWatcher()
  },

  beforeDestroy() {
    if (this.selectionWatcher) this.selectionWatcher()
  },

  methods: {
    setupSelectedRoutinesWatcher() {
      this.selectionWatcher = this.$watch(
        () => this.$refs.routineSelector?.selectedRoutines,
        this.syncActivatorSelection,
        { immediate: true }
      )
    },

    syncActivatorSelection(selectedRoutines) {
      this.$refs.routineSelectorActivator.selectedItems = selectedRoutines
    },
  },
}
</script>

<style lang="scss">
.report-routines-filter-activator-container .v-input__slot input {
  width: 0 !important;
  min-width: 0 !important;
}
</style>
